import ViewListOutlinedIcon from '@material-ui/icons/ViewListOutlined';
import TiposReglaList from './TiposReglaList';
import TiposReglaShow from './TiposReglaShow';

const tiposRegla = {
    icon: ViewListOutlinedIcon,
    list: TiposReglaList,
    show: TiposReglaShow,
};

export default tiposRegla;
